import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";
import { Controller } from "react-hook-form";

interface IDate {
  label?: string;
  name: string;
  defaultValue?: string | number;
  control: any;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  column?: number;
  maxDate?: Date;
  minDate?: Date;
  type?: string;
  dateFormat?: string;
  selectionMode?: "single" | "multiple" | "range";
  
}

export const JVDate = (props: IDate) => {
  const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
  const type = props.type ? (props.type === "month-year" ? "month" : props.type) : "date";
  return (
    <div className={className}>
      {props.label && (
        <label htmlFor={props.name}>
          {props.label}
          {props.required && <span style={{ color: "red" }}>*</span>}
        </label>
      )}
      <Controller
        name={props.name}
        control={props.control}
        defaultValue={props.defaultValue ? props.defaultValue : ""}
        render={({ field, fieldState }) => (
          <Calendar
            {...field}
            view={type}
            disabled={props.disabled}
            className={classNames({ "p-invalid": fieldState.invalid })}
            placeholder={props.placeholder}
            minDate={props.minDate}
            maxDate={props.maxDate}
            selectionMode={props.selectionMode}
            showButtonBar
            dateFormat={type === "date" ? "dd-mm-yy" : type === "year" ? "yy" : props.type === "month" ? "mm" : props.type === "month-year" ? "M-yy" : "dd-mm-yy"}
            showIcon
          />
        )}
      />
      <small className="p-error">{props.error}</small>
    </div>
  );
};
